// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__11V--","icon":"SortAdornment_icon__2oXY7","up":"SortAdornment_up__1YjqJ","down":"SortAdornment_down__e6kpU","active":"SortAdornment_active__2mQf2"};